import * as XLSX from 'xlsx';

import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';

import { ExcelPreviewDialogComponent } from '@components';
import { UserBatch } from '@models';
import { UtilService } from '@services';
import {
  fetchBatches,
  selectUserBatches,
  selectUserBatchesFetchedAt,
} from '@state';
import * as UserActions from '@state/user/user.actions';

@Component({
  selector: 'app-user-batch-upload',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDialogModule,
  ],
  templateUrl: './user-batch-upload.component.html',
  styleUrl: './user-batch-upload.component.scss',
})
export class UserBatchUploadComponent implements OnInit {
  columns: string[] = [
    'fileName',
    'totalRecords',
    'processedCount',
    'failedCount',
    'status',
    'actions',
  ];

  dataSource = new MatTableDataSource<UserBatch>();
  $userBatchesFetchedAt = this.store.select(selectUserBatchesFetchedAt);
  $userBatches = this.store.select(selectUserBatches);
  message: any;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private store: Store,
    private dialog: MatDialog,
    public utils: UtilService
  ) {}

  ngOnInit(): void {
    this.store.dispatch(fetchBatches());
  }

  public onUserBatchUploadClicked(): void {
    this.fileInput.nativeElement.click();
  }

  public onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.previewFile(file);
    }
  }

  private previewFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const dialogRef = this.dialog.open(ExcelPreviewDialogComponent, {
        width: '90%',
        maxWidth: '95vw',
        data: { fileName: file.name, previewData: jsonData },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'upload') {
          this.store.dispatch(UserActions.createBatch({ file }));
        }
        this.fileInput.nativeElement.value = '';
      });
    };
    reader.readAsArrayBuffer(file);
  }

  public downloadFile(url: any): void {
    window.open(url);
  }

  public processBatchUpload(userBatchId: string): void {
    this.store.dispatch(UserActions.processBatch({ userBatchId }));
  }
}
